import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/session")
      .then((response) => setUser(response.data.user || false))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => ({
    user,
    loading,
    isAdmin: user?.role === "admin",
    async login(email, password) {
      const response = await api.post("/auth/login", { email, password });
      setUser(response.data);
      return response.data;
    },
    async register(name, email, password) {
      const response = await api.post("/auth/register", { name, email, password });
      setUser(response.data);
      return response.data;
    },
    async logout() {
      await api.post("/auth/logout");
      setUser(false);
    },
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
